<form
  #ngForm="ngForm"
  [formGroup]="renderedFormService.formGroup"
  (ngSubmit)="ngForm.form.valid && doNothing()"
  [class.ng-submitted]="ngForm.submitted"
>
  <ng-container *ngIf="activeIndex$ | async as activeIndex">
    <ng-container *ngIf="activeSection$ | async as section" [ngSwitch]="section.type">
      <ng-container *ngSwitchCase="SectionType.Standard">
        <fl-form-section
          #currentSection
          [form]="form"
          [section]="section"
          [sectionForms]="sectionForms"
        ></fl-form-section>

        <fl-message-box *ngIf="isCurrentSectionInvalid && showWarningOnUpdate$ | async" [type]="messageBoxType.Alert">
          <p>It looks like you missed a required field. Be sure to complete anything highlighted in red above.</p>
        </fl-message-box>

        <div class="form-buttons">
          <button
            (click)="back(currentSection)"
            [disabled]="((isSubmitting$ | async) || (signatureRequestSubmitting$ | async))"
            *ngIf="activeIndex.position > 0"
            mat-button
            type="button"
          >
            Previous
          </button>
          <button
            (click)="next(activeIndex.position, currentSection, $event)"
            [disabled]="(isSubmitting$ | async) || (signatureRequestSubmitting$ | async)"
            [type]="activeIndex.position | function: determineButtonType"
            mat-button
          >
            {{ activeIndex.position | function: ctaLabel:section }}
          </button>
        </div>
      </ng-container>

      <fl-investment-profile-selector
        *ngSwitchCase="SectionType.InvestmentAccountSelection"
        (flNext)="next(activeIndex.position, null, $event)"
        [vehicle]="vehicle"
      ></fl-investment-profile-selector>

      <fl-investment-profile-summary
        *ngSwitchCase="SectionType.InvestmentAccountSummary"
        (flBack)="back()"
        (flNext)="next(activeIndex.position, null, $event)"
        (flFinalSubmit)="next(activeIndex.position, null, $event, true)"
      ></fl-investment-profile-summary>

      <fl-provider-access-request
        *ngSwitchCase="SectionType.ProviderAccessRequest"
        (flNext)="next(activeIndex.position, null, $event)"
      ></fl-provider-access-request>
    </ng-container>
  </ng-container>
</form>
